angular.module('gym.bulkMessages').factory('DebouncedUnreadRepliesService', ["$q", "$stateParams", "$http", function($q, $stateParams, $http) {
  var loadDebounced;
  loadDebounced = _.debounce((function(deferred) {
    var url;
    url = `/gyms/${$stateParams.gymId}/sms_replies/unread_count`;
    return $http.get(url).then(function(response) {
      return deferred.resolve(response.data);
    }, function(data) {
      return deferred.reject(data);
    });
  }), 250);
  return {
    load: function() {
      var deferred;
      deferred = $q.defer();
      loadDebounced(deferred);
      return deferred.promise;
    }
  };
}]);
